<template>
  <div
    id="mapWarehouse"
    class="container"
  >
    <div class="search-contaner">
      <div class="search">
        <a-input-search
          v-model="value"
          placeholder="请输入仓库、地区名称开始找仓"
          class="seek-search"
          :max-length="30"
          @search="handleSearch"
        />
        <a class="list-warehouse" @click="toList">
          <a-icon type="unordered-list" />
          列表找仓
        </a>
      </div>
      <div v-if="showList" class="search-result">
        <p class="warehouse-total">共<span>{{warehouseList.length}}</span>条结果</p>
        <div
          v-for="item in warehouseList"
          :key="item.id"
          class="warehouse-list"
          @click="checkedWarehouse(item)"
        >
          <p>
            {{item.warehouseName}}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global AMap */
import { getAreaStatics, getAreaList }  from '@/api/seekWarehouse/seekWarehouse';
import iconHouseMap from '@/assets/img/icon-house-map.png'
import { getToken } from "@/utils/auth";
import { fetchRegion } from '../api';

export default {
  name: 'MapWarehouse',
  data() {
    return {
      map: null,
      data: [],
      value: '',
      countList: [],
      markerList: [],
      apiLevel: ['province', 'city'],
      gaodeLevel: ['district', 'city'],
      warehouseList: [],
      showList: false,
      cityName: '', // 选择的省份，用于设置中心点
      cityAreaList: [], // 省市区列表
      currentCode: '', // 当前区域，防止重复请求
      autoZoom: false, // 页面缩放
      autoMove: false, // 页面拖动
      currentZoom: null,
      province: '', // 直辖市的省份
    }
  },
  created() {
    this.getAreaStatics()
    fetchRegion({}).then(res => {
      this.cityAreaList = res
    })
  },
  mounted() {
    this.map = new AMap.Map('mapWarehouse', {
      resizeEnable: true,
      zoom: 5,
      mapStyle: 'amap://styles/5415d2af821d8107c2bafa18f73bcf5b',
    })
    AMap.plugin(
      [
        'AMap.Scale',
      ],
      () => {
        this.map.addControl(new AMap.Scale())
      }
    )
    this.currentZoom = 5
    this.map.on('zoomend', () => {
      this.mapZoomAndMove('autoZoom')
    });
    this.map.on('moveend', () => {
      this.mapZoomAndMove('autoMove')
    });
  },
  methods: {
    toList() {
      this.$emit('toList')
    },
    // 搜索
    async handleSearch(value) {
      this.showList = !!value
      if(value) {
        this.warehouseList = await getAreaList({
          warehouseName: value
        })
      } else {
        this.map.setZoomAndCenter(5, [116.368324, 39.915085]);
        this.warehouseList = []
        this.getAreaStatics()
      }
    },
    // 获取地域仓库
    async getAreaStatics(code, index = 0, isClick) {
      this.clearMarker()
      if (this.apiLevel[index]) {
        const res = await getAreaStatics({
          code: index ? code : '510000',
          level: this.apiLevel[index]
        })
        this.countList = res
        this.rederMarker(index, isClick)
      } else {
        const res = await getAreaList({
          code,
          level: 'city'
        })
        this.countList = res
        this.rederWarehouse(isClick)
      }
    },
    // 根据省市名称获取code
    getCityCode(name) {
      const codeList = this.cityAreaList.filter(item => item.areaName === name || item.fullName === name)
      return codeList[0]?.areaCode || ''
    },
    // 缩放及拖动地图
    mapZoomAndMove(type) {
      // 如果是点击的省市触发的缩放和拖动，需要阻止
      if (this[type]) {
        this[type] = false
        return
      }
      const zoom = this.map.getZoom()
      if(this.currentZoom < 8 && zoom < 8) {
        this.currentZoom = zoom
        return
      }
      this.currentZoom = zoom
      this.map.getCity((info) => {
        let name = ''
        let index = 0
        let code = null
        // 层级及公里对应
        // 8 - 50  9 - 20  10 - 10
        if (zoom === 8) {
          name = info.province
          index = 1
        } else if (zoom > 8) {
          // 市级时，取高德返回的省份+市辖区在城市列表中去获取code
          name = info.city || `${info.province}市辖区`
          index = 2
        }
        if (name) {
          // 记录省市信息，用于直辖市处理
          this.province = name
          code = this.getCityCode(name)
        }
        // 如果当前省市和上次的相同，则不重新加载数据
        if(this.currentCode === code) {
          return
        }
        this.currentCode = code
        this.getAreaStatics(code, index)
      });
    },
    clearMarker() {
      if (!this.map) {
        return
      }
      this.map.remove(this.map.getAllOverlays('marker'))
    },
    checkedWarehouse(item) {
      this.autoZoom = true
      this.autoMove = true
      this.countList = [item]
      this.rederWarehouse()
      this.map.setFitView(this.markerList)
    },
    // 渲染省市仓库列表
    rederMarker(index = 0, isClick) {
      if (index && isClick) {
        this.map.setZoom(8)
        this.currentZoom = 8
      }
      AMap.plugin('AMap.DistrictSearch', () => {
        // const opts = {
        //   subdistrict: 0,   // 获取边界不需要返回下级行政区
        //   level: this.gaodeLevel[index]  // 查询行政级别
        // };
        // const district = new AMap.DistrictSearch(opts);
        const { countList } = this;
        const markerList = []
        countList.forEach(item => {
          const { cnt, name, longitude, latitude} = item
          if (cnt && name && longitude && latitude) {
            // 如果是市辖区则直接取省一级的信息进行搜索
            // const name = item.name === '市辖区' ? this.province : item.name
            // district.search(name, (status, result) => {
            //   if (status === 'complete') {
            //     let { lat, lng } = result.districtList[0]?.center || {}
            //     // 针对重庆市县的情况，在地图上查询不出来，需要更改经纬度
            //     if(name === '县' && this.province === '重庆市') {
            //       lat = 30.67545
            //       lng = 107.79998
            //     }
                const marker = new AMap.Marker({
                  offset: new AMap.Pixel(-13, -30),
                  position: new AMap.LngLat(longitude, latitude),
                })
                const markerContent = document.createElement('div')
                markerContent.className = 'marker-content'
                const markerLable = document.createElement('div')
                markerLable.innerHTML = item.name
                const markerCount = document.createElement('div')
                markerCount.innerHTML = `${item.cnt}个`
                markerContent.appendChild(markerLable)
                markerContent.appendChild(markerCount)
                marker.setContent(markerContent) // 更新点标记内容
                marker.setMap(this.map)
                markerList.push(marker)
                marker.on('click', (e) => {
                  // 点击时设置中心点击层级会触发拖动和缩放，设置变量进行阻止
                  this.autoZoom = true
                  this.autoMove = true
                  this.currentCode = item.code
                  // 记录省市信息，用于直辖市处理
                  this.province = item.name
                  this.map.setCenter([e.lnglat.getLng(), e.lnglat.getLat()])
                  this.getAreaStatics(item.code, index + 1, true)
                })
            //   }
            // })
          }
        })
        this.markerList = markerList
      })
    },
    // 渲染仓库列表
    rederWarehouse(isClick) {
      if (isClick) {
        this.map.setZoom(9)
        this.currentZoom = 9
      }
      this.clearMarker()
      const { countList } = this;
      const markerList = []
      countList.forEach(item => {
        if(!item.longitude || !item.latitude) {
          return
        }
        const marker = new AMap.Marker({
          offset: new AMap.Pixel(-13, -30),
          position: new AMap.LngLat(item.longitude, item.latitude),
        })
        const markerContent = document.createElement('div')
        markerContent.className = 'marker-warehouse'
        // 点标记中的图标
        const markerImg = document.createElement('img')
        markerImg.className = 'markerlnglat'
        markerImg.src = iconHouseMap
        markerContent.appendChild(markerImg)
        const markerSpan = document.createElement('div')
        markerSpan.className = 'marker'
        markerSpan.innerHTML = item.warehouseName
        const markerDiv = document.createElement('div')
        markerDiv.className = 'marker-div'
        markerDiv.innerHTML = ''
        markerSpan.appendChild(markerDiv)
        markerContent.appendChild(markerSpan)
        marker.setContent(markerContent) // 更新点标记内容
        marker.setMap(this.map)
        markerList.push(marker)
        marker.on('click', () => {
          let link = {}
          if (getToken()) {
            link = this.$router.resolve({path: 'seekWarehouse/detail', query: {id: item.id}})
          } else {
            link = this.$router.resolve({path: 'detail', query: {id: item.id}})
          }
          window.open(link.href,'_blank');
        })
      })
      this.markerList = markerList
    },
  }
}
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  height: calc(100vh - 64px);
  /deep/ .amap-marker-content {
    .marker-content {
      width: 72px;
      height: 72px;
      font-size: 13px;
      background: #06B880;
      border-radius: 50%;
      text-align: center;
      color: #fff;
      &:hover {
        background: #FB9432;
      }
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .marker-warehouse {
      position: relative;
      img {
        width: 80px;
        height: 56px;
      }
      .marker {
        position: absolute;
        background: #FFFFFF;
        box-shadow: 0px 0px 6px 0px #999E9E;
        font-weight: 500;
        color: #171717;
        border-radius: 4px;
        line-height: 21px;
        top: -45px;
        left: -10px;
        padding: 8px 6px;
      }
      .marker-div  {
        width: 0px;
        height: 0px;
        border-top: 10px solid #fff;
        border-left: 10px solid #fff;
        position: absolute;
        left: 32px;
        bottom: -5px;
        transform: rotate(45deg);
      }
    }
  }
  .search-contaner {
    position: absolute;
    top: 52px;
    left: 52px;
    z-index: 100;
    width: 392px;
    height: 48px;
    background: #FFFFFF;
    box-shadow: 0px 7px 12px 1px rgba(126, 126, 126, 0.15);
    border-radius: 4px;
    .search {
      display: flex;
      padding: 6px 8px;
      .seek-search {
        width: 287px;
        ::v-deep .ant-input {
          border-radius: 24px;
          border: 1px solid #E7E9EC;
          height: 36px;
          color: #171717;
          &:focus {
            box-shadow: none;
          }
        }
        &:hover {
          ::v-deep .ant-input-suffix {
            .anticon-search {
              color: #06B880;
            }
          }
        }
      }
      .list-warehouse {
        color: #646566;
        font-size: 12px;
        display: flex;
        margin-left: 33px;
        flex-direction: column;
        justify-content: space-around;
        &:hover {
          color: #06B880;
        }
      }
    }
    .search-result {
      width: 100%;
      height: 344px;
      background: #FFFFFF;
      box-shadow: 0px 7px 12px 1px rgba(126, 126, 126, 0.15);
      border-radius: 4px;
      margin-top: 8px;
      overflow-y: auto;
      .warehouse-total {
        color: #909399;
        height: 54px;
        padding: 0 24px;
        line-height: 54px;
        span {
          color: #06B880;
        }
      }
      .warehouse-list {
        height: 48px;
        line-height: 48px;
        font-weight: 500;
        color: #171717;
        p {
          margin: 0 24px;
          border-top: 1px solid #EBEDF0;
        }
        &:hover {
          background: #F2FBF8;
          color: #06B880;
        }
      }
    }
  }
}
</style>